import { render, staticRenderFns } from "./HelpDeskEditScreenshot.vue?vue&type=template&id=7c9feaae&scoped=true"
import script from "./HelpDeskEditScreenshot.vue?vue&type=script&lang=js"
export * from "./HelpDeskEditScreenshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9feaae",
  null
  
)

export default component.exports